"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_country__or__international(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4c07fc88-d45b-4755-970b-91c664309f04",
    "data-name": "country-or-international-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "13cbd3c9-d0e4-4727-8cfa-c3a54a5b9f24",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96.29,
    r: 80,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "country-or-international-hi"), /*#__PURE__*/React.createElement("g", {
    id: "df33c522-813b-456b-a103-7709c953a2fb",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e242fb4d-1363-438c-b0ec-345212e15195",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "43d77ff8-df59-4965-bb38-44628c91dd45",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ef1c40fa-f492-40ab-a4dd-9bfbe5cabfe8",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c8875135-85e7-4aaf-aedb-13918318c74a",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "20a68c9d-846d-4c17-8196-4a5d04640d11",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1148525e-1ea2-4fb3-98c3-7252f38fc586",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0ad1dbab-92ce-4db9-9807-2c798c40f4e5",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1769022-e54d-45a2-ba8d-b37a6969f285",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fa9f4989-954a-4966-980e-5367b0e3af04",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6a2bf758-d77f-4d78-a0aa-039e3966eee1",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5a9f9f0b-5156-4334-b314-aa544bb98a3c",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1477f1d-d0ce-4583-bcae-5f385303b8b1",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01ebb164-882d-4686-a0f8-a4220e51dfa7",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f23afdac-64d4-4ff2-8b03-fc0de5afed75",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7fb2e84d-b138-4088-a9e4-9b4e65edf986",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1000d20a-524d-43ac-a79a-a31737d45c40",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7c8cf57b-75a5-4a7a-bf52-eb0c28b42179",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8b942f6e-aa5c-4851-aa5a-d9976ac1394a",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "296a5d71-4f49-46a8-8d4f-e4a6e22f64da",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "54ea9507-2220-487e-b665-fce8708100ba",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a10f8cd5-bcf8-4b8f-a041-df95e482d0c8",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "79c13bc2-bb35-4e6c-a072-08ef65d0af43",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e0d5b08b-c533-4549-8617-657b696902cc",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "41f25f6a-0612-4102-a52a-0662fb63b987",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24749ea2-1e97-4d2a-a09e-e4b84ae8ec3e",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "39137bbc-2027-4a94-af2d-80adbe65ea36",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96.29,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.29a80,80,0,0,0,80-79c0,.33,0,.66,0,1a80,80,0,1,1-160,0c0-.34,0-.67,0-1A80,80,0,0,0,96,174.29Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13cbd3c9-d0e4-4727-8cfa-c3a54a5b9f24)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,55.29c0,11.6,31.34,21,70,21s70-9.4,70-21",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,23.79c0,5.8,15.67,10.5,35,10.5s35-4.7,35-10.5",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,139.29c0,11.6,31.34,21,70,21s70-9.4,70-21",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "d28f1528-461a-4109-abf1-61158e8054ec",
    "data-name": "<Pfad>",
    d: "M90.65,12.71C65.57,34.23,47.75,63.28,47.75,95.5c0,31.78,18.27,61.38,42.9,82.79",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "ec707b86-bde1-4474-a579-d3af2b72b49b",
    "data-name": "<Pfad>",
    d: "M104.72,12.71c25.08,21.52,42.9,50.57,42.9,82.79,0,31.78-18.27,61.38-42.9,82.79",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "1d31195c-259f-48f4-a6e2-6df359b1da1b",
    "data-name": "<Pfad>",
    x1: 97.68,
    y1: 178.29,
    x2: 97.68,
    y2: 14.41,
    opacity: 0.06,
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,97.29c0,13.92,37.61,25.2,84,25.2s84-11.28,84-25.2",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    transform: "translate(192 192) rotate(-180)",
    fill: "none"
  })))))))))))))))))))))))))))));
}

var _default = ic_country__or__international;
exports.default = _default;